import { StaticImage } from 'gatsby-plugin-image';
import { useStaticQuery, graphql } from 'gatsby';
import { Link, useIntl } from 'gatsby-plugin-intl';
import React, { useEffect, useState } from 'react';
import '../css/footer-css.css';
import '../css/general-css.css';
import '../css/header-css.css';
import Language from './language';

export default function Header() {

  const data = useStaticQuery(graphql`
    query {
      wp {
        globalOptions {
          ACFgeneralOptionsFields {
            bannerCtaLink {
              ... on WpPage {
                uri
              }
            }
            bannerCtaText
            bannerText
          }
        }
      }
    }
  `)
  console.log(data);
  const { bannerCtaLink, bannerCtaText, bannerText } = data.wp.globalOptions.ACFgeneralOptionsFields;

  const intl = useIntl();
  const isEnglishLocale = intl.locale === 'en';
  const isDeLocale = intl.locale === 'de';
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    document.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const [isBurgerVisible, setIsBurgerVisible] = useState(true);
  const [isCloseVisible, setIsCloseVisible] = useState(false);

  const handleClick = () => {
    document.getElementById('bs-navbar').classList.toggle('slide-menu');
    document
      .getElementsByClassName('navbar-header')[0]
      .classList.toggle('active-menu');
    document.body.classList.toggle('m-menu-active');
    if (isBurgerVisible) {
      setIsBurgerVisible(false);
      setIsCloseVisible(true);
    } else {
      setIsBurgerVisible(true);
      setIsCloseVisible(false);
    }
  };

  return (
    <div>
      {isEnglishLocale && (
        <div className='blue-head-bar'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <p>{bannerText} <Link to={bannerCtaLink.uri}>{bannerCtaText}</Link>. </p>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className='top-head-bar h-hide-desk'>
        <ul className='tp-menu-list'>
          <li>
            <a href='https://ir.eksobionics.com/' target='_blank'>{intl.formatMessage({ id: 'investors' })}</a>
          </li>
          <li>
            <Link to='/centers/'>
              {intl.formatMessage({ id: 'find_a_center' })}
            </Link>
          </li>
          {isEnglishLocale && (
            <li>
              <a
                href='https://shop.eksobionics.com/'
                target='_blank'
              >
                Shop
              </a>
            </li>
          )}
          <li>
            <Link to='/request-information/'>
              {intl.formatMessage({
                id: 'request_information',
              })}
            </Link>
          </li>
        </ul>
      </div>
      <header className={`header ${scrolled ? 'fixed-header' : ''}`}>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-2 brand'>
              {' '}
              <Link to='/'>
                {scrolled ? (
                  <StaticImage
                    src='../images/Logo_EksoBionics_Horiz_website1.svg'
                    className='fixed-logo'
                    alt='Ekso logo'
                  />
                ) : (
                  <StaticImage
                    src='../images/Logo_EksoBionics_Horiz_website2.svg'
                    className='static-logo'
                    alt='Ekso logo'
                  />
                )}
              </Link>{' '}
            </div>
            <div className='col-sm-10 header-mid-col'>
              <div className='row'>
                <div className='col-sm-11'>


                  <div className='row h-hide-m'>
                    <div className='col-md-12'>
                      <div className='top-head-bar'>
                        <ul className='tp-menu-list'>
                          <li>
                            <a href='https://ir.eksobionics.com/' target='_blank'>
                              {intl.formatMessage({ id: 'investors' })}</a>
                          </li>
                          <li>
                            <Link to='/centers/'>
                              {intl.formatMessage({ id: 'find_a_center' })}
                            </Link>
                          </li>
                          {isEnglishLocale && (
                            <li>
                              <a
                                href='https://shop.eksobionics.com/'
                                target='_blank'
                              >
                                Shop
                              </a>
                            </li>
                          )}
                          <li>
                            <Link to='/request-information/'>
                              {intl.formatMessage({
                                id: 'request_information',
                              })}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>
                <div className='col-sm-1 header-rt-col h-hide-m'>
                  <Language />
                </div>
              </div>
              <nav className='navbar'>
                <div className='navbar-header'>
                  <button
                    onClick={handleClick}
                    className='menu-btn'
                    style={{ background: 'none' }}
                  >
                    {isBurgerVisible && (
                      <svg
                        width='20'
                        height='14'
                        viewBox='0 0 20 14'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1 1.00098H19M1 7.00098H19M1 13.001H19'
                          stroke='white'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    )}
                    {isCloseVisible && (
                      <StaticImage
                        src='../images/close-icon.png'
                        alt='close icon'
                      />
                    )}
                  </button>{' '}
                </div>
                <div id='bs-navbar'>
                  <ul className='nav navbar-nav'>
                    <li className='dropdown'>
                      <Link to='/'>
                        {intl.formatMessage({
                          id: 'for_personal_use',
                        })}
                      </Link>
                      <div className='megamenu-multilevel'>
                        <ul className='my-megamenu'>
                          <li>
                            <div className='megamenu-title pointer-event-none'>
                              <Link to='/'>
                                {intl.formatMessage({ id: 'products' })}
                              </Link>
                            </div>
                            <ul className='sub-menu'>
                              <li>
                                <Link to='/ekso-indego-personal/'>
                                  Ekso Indego Personal
                                </Link>
                              </li>
                              <li className='h-hide-desk'>
                                <Link to='/veterans/'>
                                  {intl.formatMessage({ id: 'veterans' })}
                                </Link>
                              </li>
                              {isEnglishLocale && (
                                <li className='h-hide-desk'>
                                  <Link to='/medicare/'>
                                    Medicare Recipients
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </li>
                          <li className='h-hide-m'>
                            <div className='megamenu-title pointer-event-none empty-title'>
                              <Link to='/'>&nbsp;
                              </Link>
                            </div>
                            <ul className='sub-menu'>
                              <li>
                                <Link to='/veterans/'>
                                  {intl.formatMessage({ id: 'veterans' })}
                                </Link>
                              </li>
                              {isEnglishLocale && (
                                <li>
                                  <Link to='/medicare/'>
                                    Medicare Recipients
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className='dropdown'>
                      <Link to='/'>
                        {intl.formatMessage({
                          id: 'for_clinical_use',
                        })}
                      </Link>
                      <div className='megamenu-multilevel'>
                        <ul className='my-megamenu'>
                          <li>
                            <div className='megamenu-title pointer-event-none'>
                              <Link to='/eksoworks/'>
                                {intl.formatMessage({ id: 'products' })}
                              </Link>
                            </div>
                            <ul className='sub-menu'>
                              <li>
                                <Link to='/eksohealth/'>
                                  {intl.formatMessage({
                                    id: 'eksohealth_overview',
                                  })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/eksonr/'>
                                  EksoNR
                                </Link>
                              </li>
                              <li>
                                <Link to='/ekso-indego-therapy/'>
                                  Ekso Indego Therapy
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <div className='megamenu-title'>
                              <Link to='/' className='pointer-event-none'>
                                {intl.formatMessage({ id: 'for_indications' })}
                              </Link>
                            </div>
                            <ul className='sub-menu'>
                              <li>
                                <Link to='/acquired-brain-injury/'>
                                  {intl.formatMessage({
                                    id: 'acquired_brain_injury',
                                  })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/spinal-cord-injury/'>
                                  {intl.formatMessage({
                                    id: 'spinal_cord_injury',
                                  })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/multiple-sclerosis/'>
                                  {intl.formatMessage({
                                    id: 'multiple_sclerosis',
                                  })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/eksonr-and-stroke-rehabilitation/'>
                                  {intl.formatMessage({ id: 'stroke' })}
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>
                    {isEnglishLocale && (
                      <li className='dropdown blank-li'></li>
                    )}
                    {isDeLocale && (
                      <li className='dropdown dedropdownmenu'>
                        <Link to='/'>
                          {intl.formatMessage({ id: 'industrial_use' })}
                        </Link>
                        <div className='megamenu-multilevel'>
                          <ul className='my-megamenu'>
                            <li>
                              <div className='megamenu-title pointer-event-none'>
                                <Link to='/'>
                                  {intl.formatMessage({ id: 'products' })}
                                </Link>
                              </div>
                              <ul className='sub-menu'>
                                <li>
                                  <Link to='/eksoworks/'>
                                    {intl.formatMessage({ id: 'eksoworks_overview' })}
                                  </Link>
                                </li>
                                <li>
                                  <Link to='/ekso-evo/'>
                                    {intl.formatMessage({ id: 'evo' })}
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <div className='megamenu-title pointer-event-none empty-title'>
                                <Link to='/'>
                                  Anwendungen
                                </Link>
                              </div>
                              <ul className='sub-menu'>
                                <li>
                                  <Link to='/construction/'>
                                    {intl.formatMessage({ id: 'construction' })}
                                  </Link>
                                </li>
                                <li>
                                  <Link to='/manufacturing/'>
                                    {intl.formatMessage({ id: 'manufacturing' })}
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </li>
                    )}
                    <li className='dropdown'>
                      <Link to='/'>
                        {intl.formatMessage({ id: 'products' })}
                      </Link>
                      <div className='megamenu-multilevel'>
                        <ul className='my-megamenu'>
                          <li>
                            <ul className='sub-menu'>
                              <li>
                                <Link to='/eksonr/'>
                                  EksoNR
                                </Link>
                              </li>
                              <li>
                                <Link to='/ekso-indego-therapy/'>
                                  Ekso Indego Therapy
                                </Link>
                              </li>
                              <li>
                                <Link to='/ekso-indego-personal/'>
                                  Ekso Indego Personal
                                </Link>
                              </li>
                              <li>
                                <Link to='/ekso-evo/'>
                                  {intl.formatMessage({ id: 'evo' })}
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className='dropdown'>
                      <Link to='/'>
                        {intl.formatMessage({ id: 'for_more' })}
                      </Link>
                      <div className='megamenu-multilevel'>
                        <ul className='my-megamenu'>
                          <li>
                            <div className='megamenu-title pointer-event-none'>
                              <Link to='/'>
                                {intl.formatMessage({ id: 'resources' })}
                              </Link>
                            </div>
                            <ul className='sub-menu'>
                              <li>
                                <Link to='/customer-stories/'>
                                  {intl.formatMessage({
                                    id: 'customer_stories',
                                  })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/webinars/'>
                                  {intl.formatMessage({ id: 'webinars' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/research/'>
                                  {intl.formatMessage({ id: 'research' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/faq/'>
                                  {intl.formatMessage({ id: 'faq' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/training/'>
                                  {intl.formatMessage({ id: 'training' })}
                                </Link>
                              </li>
                              <li> <a href='https://pulse.eksobionics.com/' target="_blank"> {intl.formatMessage({ id: 'eksopulse' })} </a> </li>
                              <li>
                                <Link to='/centers-of-excellence'>
                                  {intl.formatMessage({
                                    id: 'centers_of_excellence',
                                  })}
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <div className='megamenu-title pointer-event-none'> <Link to='/'> {intl.formatMessage({ id: 'company' })} </Link></div>
                            <ul className='sub-menu'>
                              <li>
                                <Link to='/about-us/'>
                                  {intl.formatMessage({ id: 'about_us' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/blog/'>
                                  {intl.formatMessage({ id: 'ekso_blog' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/news-and-events/'>
                                  {intl.formatMessage({ id: 'news_events' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/careers/'>
                                  {intl.formatMessage({ id: 'careers' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/distributors/'>
                                  {intl.formatMessage({ id: 'distributors' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/past-products/'>
                                  {intl.formatMessage({ id: 'past_products' })}
                                </Link>
                              </li>
                              <li>
                                <Link to='/contact/'>
                                  {intl.formatMessage({ id: 'contact_us' })}
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className='col-sm-1 header-rt-col h-hide-desk'>
              <Language />
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}
